module.exports = __webpack_public_path__ + "static/p12-04c8b5ca909b1a2726b1a8ebaee67e46.png";